import { useEffect, useState } from "react";
import SVG from "react-inlinesvg";
import AdSlot300x250 from "../Ads/AdSlot300x250";
import AdSlot728x90 from "../Ads/AdSlot728x90";
const SeriesStats = ({ statsData = null, scrolled = false }) => {
  const [currentStat, setCurrentStat] = useState(1);
  const [expandIdx, setExpandIdx] = useState(0);
  const [currentStatData, setCurrentStatData] = useState(
    statsData
      ? statsData?.filter((stat) => stat.statName == "Highest Score")[0]
      : null
  );

  const toggleIdx = (idx) => {
    setExpandIdx(idx == expandIdx ? null : idx);
  };
  useEffect(() => {
    let tempStats = [];
    if (currentStat == 1) {
      tempStats = [
        { statName: "Highest Score" },
        { statName: "Most Runs" },
        { statName: "Best Batting Average" },
        { statName: "Best Strike Rate" },
        { statName: "Most Fifties" },
        { statName: "Most Hundreds" },
      ];
    } else {
      tempStats = [
        { statName: "Most Wickets" },
        { statName: "Best Economy Rates" },
      ];
    }
    setStatsArr(tempStats);
  }, [currentStat]);

  useEffect(() => {
    let tempStats = {
      0: currentStatData,
    };
    if (currentStat == 1) {
      tempStats = {
        0: statsData?.filter((stat) => stat.statName == "Highest Score")[0],
        1: statsData?.filter((stat) => stat.statName == "Most Runs")[0],
        2: statsData?.filter(
          (stat) => stat.statName == "Best Batting Average"
        )[0],
        3: statsData?.filter((stat) => stat.statName == "Best Strike Rate")[0],
        4: statsData?.filter((stat) => stat.statName == "Most Fifties")[0],
        5: statsData?.filter((stat) => stat.statName == "Most Hundreds")[0],
      };
    } else {
      tempStats = {
        0: statsData?.filter((stat) => stat.statName == "Most Wickets")[0],
        1: statsData?.filter((stat) => stat.statName == "Best Economy Rates")[0],
      };
    }
    setCurrentStatData(tempStats[expandIdx]);
  }, [currentStat, expandIdx]);

  const [statsArr, setStatsArr] = useState([
    { statName: "Highest Score" },
    { statName: "Most Runs" },
    { statName: "Best Batting Average" },
    { statName: "Best Strike Rate" },
    { statName: "Most Fifties" },
    { statName: "Most Hundreds" },
  ]);
  return (
    <>
      {statsData && statsData[0]?.statLeaderBoard?.length ? (
        <div className="py-2">
          <div className="flex gap-0 py-2 border-b border-gray-300 text-[#00000099] text-md">
            <div
              onClick={() => {
                setCurrentStat(1);
              }}
              className={`cursor-pointer w-[20%] text-center ${currentStat == 1
                ? "-mb-2 text-primary border-primary border-b-2"
                : ""
                }`}
            >
              Batting
            </div>
            <div
              onClick={() => {
                setCurrentStat(2);
              }}
              className={`cursor-pointer w-[20%] text-center ${currentStat == 2
                ? "-mb-2 text-primary border-primary border-b-2"
                : ""
                }`}
            >
              Bowling
            </div>
          </div>
          {statsData ? (
            statsArr.map((item, index) => {
              return (
                <div key={index} className="flex flex-col gap-2 mt-4">
                  <div className="rounded-lg border border-[#F1F2F6]">
                    <div
                      className="cursor-pointer p-4 flex justify-between bg-[#F1F2F6]"
                      onClick={() => toggleIdx(index)}
                    >
                      {item.statName}
                      <span className="transition-transform duration-500">
                        {expandIdx == index ? (
                          <SVG
                            src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/down.svg"
                            className="w-4 h-4"
                          />
                        ) : (
                          <SVG
                            src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/right.svg"
                            className="w-4 h-4 mt-[0.3rem]"
                          />
                        )}
                      </span>
                    </div>
                    {expandIdx == index && (
                      <div className="w-[95%] my-2 mx-auto rounded-lg border border-[#F1F2F6] flex flex-col gap-2">
                        <div className="px-4 py-2 flex justify-between bg-[#F1F2F6]">
                          <div className="w-[50%] md:w-[60%] flex gap-4 text-sm justify-start">
                            <span>Pos</span>
                            <span>Player Name</span>
                          </div>
                          <div className="w-[50%] md:w-[40%] flex gap-4 text-sm justify-end">
                            {/* stat headers  */}
                            <div className="w-[20%] md:w-[10%] text-center">
                              {currentStat == 1
                                ? expandIdx == 0
                                  ? "Balls"
                                  : "Inn"
                                : "Overs"}
                            </div>
                            <div className="w-[20%] md:w-[15%] text-center">
                              {currentStat == 1
                                ? expandIdx == 2
                                  ? "Avg."
                                  : expandIdx == 3
                                    ? "SR"
                                    : expandIdx == 0 || expandIdx == 1
                                      ? "Score"
                                      : "Count"
                                : expandIdx == 0
                                  ? "Wickets"
                                  : "Econ."}
                            </div>
                          </div>
                        </div>
                        <div>
                          {currentStatData?.statLeaderBoard?.map(
                            (item, index) => {
                              return (
                                <div
                                  key={index}
                                  className="px-4 py-2 flex justify-between border-b border-[F1F2F6] last:border-none"
                                >
                                  <div className="w-[50%] md:w-[60%] flex gap-4 text-sm items-center justify-start">
                                    <div className="w-[10%] md:w-[5%]">
                                      {index + 1}
                                    </div>
                                    <div className="w-[50%] md:w-[60%] flex gap-2 items-center">
                                      <img
                                        src={`https://akm-img-a-in.tosshub.com/sites/live-score/resources-live/images/flag_img_st/players/asia-cup/${item.player_id}.jpg`}
                                        alt="player_logo"
                                        width={50}
                                        height={50}
                                        onError={(e) => {
                                          e.target.src =
                                            "https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/0.png";
                                        }}
                                        className="w-[40px] h-[40px] md:w-[50px] md:h-[50px] rounded-full"
                                      />
                                      {item.player_name}
                                    </div>
                                  </div>
                                  <div className="w-[50%] md:w-[40%] flex gap-4 text-sm justify-end items-center">
                                    {/* stat values  */}
                                    <div className="w-[20%] md:w-[10%] text-center">
                                      {currentStat == 1
                                        ? expandIdx == 0
                                          ? item.balls_faced
                                          : item.innings_played
                                        : item.overs}
                                    </div>
                                    <div className="w-[20%] md:w-[15%] text-center">
                                      {currentStat == 1
                                        ? expandIdx == 0
                                          ? item.highest_score
                                          : expandIdx == 1
                                            ? item.runs_scored
                                            : expandIdx == 2
                                              ? item.average
                                              : expandIdx == 3
                                                ? item.batting_strike_rate
                                                : expandIdx == 4
                                                  ? item.fifties
                                                  : expandIdx == 5
                                                    ? item.hundred
                                                    : ""
                                        : expandIdx == 0
                                          ? item.wickets
                                          : item.economy}
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="w-full flex flex-col items-center justify-center text-lg text-gray-500 mt-10 mb-12">
              <SVG
                src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/NoMatchData.svg"
                className="w-22 h-122 rounded-full mb-4"
              />
              Stats Not Available Yet!
            </div>
          )}
        </div>
      ) : (
        <div className="w-full flex flex-col items-center justify-center text-lg text-gray-500 mt-10 mb-12">
          <SVG
            src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/NoMatchData.svg"
            className="w-22 h-122 rounded-full mb-4"
          />
          Stats Not Available Yet!
        </div>
      )}
      {scrolled && (<div className="mx-4"> <AdSlot300x250
        divId="div-gpt-ad-1659434604998-0"
        minWidth="300px"
        minHeight="250px"
      /> </div>)}

      {scrolled && <AdSlot728x90
        divId="div-gpt-ad-1707804176041-2"
        minWidth="728px"
        minHeight="90px"
      />}
    </>
  );
};

export default SeriesStats;
